import React from "react";
import BrandLogo, { BRAND_NAME } from "components/BrandLogo";
import MountainRidge from "components/MountainRidge";
import { Phone, Clock, Facebook, Truck, ShoppingCart, Wallet } from "lucide-react";
import useSiteSettings, { splitPhones } from "utils/useSiteSettings";

const Footer = () => {
  const { get } = useSiteSettings();
  const phones = splitPhones(get("footer.phone"));
  const fb = get("services.facebookUrl");

  const services = [
    { icon: Truck, text: get("footer.service1") },
    { icon: ShoppingCart, text: get("footer.service2") },
    { icon: Wallet, text: get("footer.service3") },
  ].filter((s) => s.text);

  const Heading = ({ children }) => (
    <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-primary">{children}</h4>
  );

  return (
    <footer id="contact" className="scroll-mt-20">
      {/* Дээд ирмэг: уулын нуруу (дээд хэсэг нь тунгалаг тул аль ч дэвсгэртэй хуудсанд тохирно) */}
      <MountainRidge layers={["fill-primary/70", "fill-brand-blue-dark"]} className="h-12 md:h-20 -mb-px" />
      <div className="bg-brand-blue-dark text-white">
        <div className="container mx-auto px-4 pt-10 pb-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10">
            {/* Брэнд */}
            <div className="lg:col-span-4">
              <BrandLogo size={44} tone="light" />
              <p className="mt-5 text-sm text-white/70 leading-relaxed max-w-sm">{get("hero.subtitle")}</p>
              {fb && (
                <a
                  href={fb}
                  target="_blank"
                  rel="noreferrer"
                  className="mt-5 inline-flex items-center gap-2 rounded-full bg-white/10 hover:bg-primary px-4 py-2 text-sm font-semibold transition-colors"
                >
                  <Facebook className="w-4 h-4" /> Facebook group
                </a>
              )}
            </div>

            {/* Үйлчилгээ */}
            <div className="lg:col-span-3">
              <Heading>{get("footer.servicesTitle")}</Heading>
              <ul className="mt-5 space-y-3">
                {services.map((s, i) => (
                  <li key={i} className="flex items-start gap-3 text-sm text-white/80">
                    <s.icon className="w-4 h-4 mt-0.5 text-primary shrink-0" />
                    <span>{s.text}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Цагийн хуваарь */}
            <div className="lg:col-span-2">
              <Heading>{get("footer.hoursTitle")}</Heading>
              <p className="mt-5 flex items-start gap-3 text-sm text-white/80 whitespace-pre-line">
                <Clock className="w-4 h-4 mt-0.5 text-primary shrink-0" />
                <span>{get("footer.hours")}</span>
              </p>
            </div>

            {/* Холбоо барих */}
            <div className="lg:col-span-3">
              <Heading>{get("footer.contactTitle")}</Heading>
              <ul className="mt-5 space-y-3">
                {phones.map((p) => (
                  <li key={p}>
                    <a href={`tel:${p}`} className="inline-flex items-center gap-3 font-display text-lg font-bold hover:text-primary transition-colors">
                      <span className="w-9 h-9 rounded-xl bg-white/10 flex items-center justify-center">
                        <Phone className="w-4 h-4 text-primary" />
                      </span>
                      {p}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/50">
            <span>{get("footer.copyright")}</span>
            <span>{BRAND_NAME} · Эрээн – Говь-Алтай</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
